import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from './services/authentication.service';
import { HealthCheckService } from './services/health-check.service';
import { PpsUtilityService } from './services/pps-utility.service';
import { AppStatus } from './shared/models/app-status';

@Component({
  selector: 'pps-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent{
  spinnerName: string = "AppLoadingSpinner";

  healthCheckInterval = 300000;
  title = 'pps-client';
  AppStatus = AppStatus;
  appLoadingStatus: AppStatus = 0;
  appLoadingStatusMsg = "";

  constructor(private _util: PpsUtilityService,
              private _spinner: NgxSpinnerService,
              private _authService: AuthenticationService,
              private _healthService: HealthCheckService){
    this._spinner.show(this.spinnerName);

    this._authService.appLoaded.subscribe(appLoadingStatus => {
      console.log("App loading status: " + appLoadingStatus)
      this.appLoadingStatus = appLoadingStatus;
      switch(appLoadingStatus){
        case AppStatus.Initialized: this.appLoadingStatusMsg = "Application initialized"; break;
        case AppStatus.LoginStarted: this.appLoadingStatusMsg = "Signing in..."; break;
        case AppStatus.LoginCompleted: this.appLoadingStatusMsg = "You have been authenticated"; break;
        case AppStatus.LogoutStarted: this.appLoadingStatusMsg = "Signing out..."; break;
        case AppStatus.LogoutCompleted: this.appLoadingStatusMsg = "Signed out"; break;
        case AppStatus.UserContextLoading: this.appLoadingStatusMsg = "Application loading..."; break;
        case AppStatus.Ready: 
          this.appLoadingStatusMsg = "Application ready"; 
          window.setTimeout(() => this.healthCheck(), this.healthCheckInterval);
          this._spinner.hide(this.spinnerName);
          break;
      }
    });
  }

  healthCheck(){
    this._healthService.healthCheck()
      .subscribe()
      .add(() => {
        window.setTimeout(() => this.healthCheck(), this.healthCheckInterval);
      });
  }

  get isLocalOrDevelopment(): boolean{
    return this._util.isLocalOrDevelopment;
  }
  
  get isTest(): boolean{
    return this._util.isTest;
  }
  
  get isProduction(): boolean{
    return this._util.isProduction;
  }
}
